var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: "alert alert-" + _vm.colorClass, attrs: { role: "alert" } },
    [
      _c("font-awesome-icon", {
        staticClass: "mr-1",
        attrs: { icon: ["fad", "info-circle"] }
      }),
      _vm._v(" "),
      _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }